import React from "react";
import { Outlet } from "react-router-dom";

import SideBar from "./sideBar";
import TopBar from "./topBar";
import Navbar from "./Navbar";
import { Footer, Breadcrumb } from "../components/ui/layout";

const MainLayout = () => {
  return (
<div className="flex h-screen overflow-hidden bg-gray-100">
      <aside className="hidden lg:flex lg:flex-col w-64 shrink-0 border bg-white">
        <SideBar />
      </aside>
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <header className="lg:hidden border-b border-gray-200 bg-white">
          <TopBar />
        </header>

        <header className="hidden lg:block bg-white px-4 py-2">
          <Navbar />
        </header>

        <main className="flex-1 overflow-y-auto">
          <div className="px-6 py-4">
            <Breadcrumb />
            <Outlet />
          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default MainLayout;
